import React, { Attributes, useEffect, useState } from "react";
import { json } from "stream/consumers";
import { AuditPropVM, AuditTrialVM } from "../../Models/ViewModels";
type attributes = {
   data:AuditTrialVM[]
  }

export const AuditInfo=(props:attributes)=>{
 
  

  if(props.data.length>0){
    return(
        
        <div style={{ height:'auto'}} className="table-responsive">
            <table className="table" >
                <thead>
                    <th scope="col" className="text-center" colSpan={4}>Recent Changes</th>
                </thead>
                <tbody >
                <tr>
                    <th scope="col">Field Name</th>
                    <th scope="col">Previous Value</th>
                    <th scope="col">New Value</th>
                    <th scope="col">Updated On</th>
                </tr>
             
                {props.data.map((d:AuditTrialVM)=>{
                    return(
                    <tr>
                        <td>{d.FieldName}</td>
                        <td>{d.PreviousValue}</td>
                        <td>{d.NewValue}</td>
                        <td>{d.UpdatedOn}</td>
                    </tr>)
                })}
                
                </tbody>
            </table>
        </div>
  )}
  else{
    return<></>
  }
           
    
            
   
}
